import List from "@/components/list";
import router from "@/router";

const Table = args => {

  const AccountTableConfig = [
    {
      label: "姓名",
      minWidth: "100",
      prop: "userName",
    },
    {
      label: "单位及职务",
      minWidth: "160",
      showOverflowTooltip: true,
      prop: "unitPosition",
    },
    {
      label: "预约时间",
      prop: "ticketDateStr",
      minWidth: "100",
    },
    {
      label: "学习时长",
      prop: "visitTimeStr",
      minWidth: "80",
    },
    {
      label: "获得学时",
      prop: "credit",
      minWidth: "60",
    },
  ];

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
